export enum AuthActionTypes {
  AUTHENTICATE = "@@auth/AUTHENTICATE",
}
